export default /^[\w-.+]+@([\w-]+\.)+[\w-]{2,5}$/;
